import React, { useState, useEffect } from 'react'
import { AppBar, Tabs, Tab } from '@material-ui/core'
import TabPanel from './TabPanel'
import SwipeableViews from 'react-swipeable-views'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import MetricsDetailContent from '../metricAnalyticWithTabs/MetricsDetailContent'
import { additionalStyleProps } from '../metricAnalyticWithTabs/helpers'
import CircularProgress from '@material-ui/core/CircularProgress'
import { FormattedMessage } from 'react-intl'
import {
  colors,
  LIKES,
  REPORTS,
  LIKED,
  DIDNTlIKE,
  RECEIVED,
  NOTRECEIVE,
  FEEDREAD,
  READ,
  DIDNTREAD,
  FULL_LISTENED,
  LISTENED,
  DIDNT_LISTENED,
  OPENED,
  DIDNT_OPEN,
  DELIVER,
  REACTION,
  SOCIAL_MEDIA_INTERACTIONS,
  APP,
  EMAIL,
  SMS,
  AUTOMATE_CALL,
  CHANNEL_APP_TEXT,
  CHANNEL_EMAIL_TEXT,
  CHANNEL_SMS_TEXT,
  CHANNEL_AUTOMATE_CALL,
  tabs,
} from '../metricAnalyticWithTabs/constants'
import SocialMediaInteractionsTab from './SocialMediaInteractionsTab/SocialMediaInteractionsTab.jsx'
import { useIntl } from 'react-intl'
import * as R from 'ramda'
import clsx from 'clsx'
import Assets from 'app/configs/assetConfigs'
import { useAppName, useAppLogo } from 'commons/usePartner'

const useStyles = makeStyles((theme) => ({
  MuiPaperRoot: {
    borderRadius: '2.8rem',
    boxShadow: 'none',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  selectedTab: {
    backgroundColor: 'white',
    borderRadius: '2.8rem',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.12)',
    color: '#0073b1',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '1.14',
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  MuiTabsFlexContainer: {
    padding: '2px',
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  tabStyle: {
    textTransform: 'capitalize',
  },
  darkGreyText: {
    color: theme.palette.darkGrey.main,
  },
  circleStyle: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    margin: '0.5rem 0.7rem 0 0',
    paddingRight: '0.7rem',
  },
  descriptionContainer: {
    display: 'flex',
    padding: '1rem 0',
  },
}))

const TabsContainer = ({
  tabTitles,
  setType,
  tabType,
  tabDetail,
  catchedError,
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const { formatMessage } = useIntl()
  const appName = useAppName()
  const { logo: appLogo } = useAppLogo()

  const [value, setValue] = useState(0)
  const [isShow, setIsShow] = useState(true)
  const [listForStackedBarChart, setListForStackedBarChart] = useState([])
  const [arrayForFlags, setArrayForFlags] = useState([])
  useEffect(() => {
    setIsShow(true)
  }, [tabDetail])

  let messageForEmptyCase
  useEffect(() => {
    let arr = [],
      flagsArray = []
    // eslint-disable-next-line no-unused-vars
    for (let value in tabDetail) {
      let color = '',
        title
      let tabDetailValue =
        tabDetail[value] === null
          ? 0
          : tabDetail[value].length || tabDetail[value]
      switch (value) {
        case FULL_LISTENED:
          color = colors.green
          break
        case LISTENED:
          color = colors.yellow
          break
        case DIDNT_LISTENED:
          color = colors.red
          title = (
            <FormattedMessage
              id="metrics.didnt.listened.hover.message"
              values={{ count: tabDetailValue }}
            />
          )
          break
        case READ:
          color = colors.green
          break
        case DIDNTREAD:
          color = colors.gray
          title = (
            <FormattedMessage
              id="metrics.didnt.read.hover.message"
              values={{ count: tabDetailValue }}
            />
          )
          break
        case FEEDREAD:
          color = colors.yellow
          break
        case OPENED:
          color = colors.green
          break
        case DIDNT_OPEN:
          color = colors.red
          title = (
            <FormattedMessage
              id="metrics.didnt.media.opened.hover.message"
              values={{ count: tabDetailValue }}
            />
          )
          break
        default:
          break
      }
      if (tabDetail[LIKES] && tabDetail[REPORTS]) {
        tabDetail[LIKES][LIKED] &&
          arr.push({
            value: tabDetail[LIKES][LIKED].length,
            backgroundColor: colors.green,
            title: title || messageForEmptyCase,
          })
        tabDetail[LIKES][DIDNTlIKE] &&
          arr.push({
            value: tabDetail[LIKES][DIDNTlIKE].length,
            backgroundColor: colors.red,
            title: (
              <FormattedMessage
                id="metrics.didnt.like.hover.message"
                values={{ count: tabDetail[LIKES][DIDNTlIKE].length }}
              />
            ),
          })
        tabDetail[REPORTS] &&
          flagsArray.push(
            {
              value: tabDetail[REPORTS]['1'].length,
              backgroundColor: colors.orange_1,
              title: (
                <FormattedMessage
                  id="notificationTimeline.card.metric.inappropriate.sexualContent.tooltip"
                  values={{
                    value: tabDetail[REPORTS]['1'].length,
                    b: (text) => <span className="font-bold">{text}</span>,
                    newline: <br />,
                  }}
                />
              ),
            },
            {
              value: tabDetail[REPORTS]['2'].length,
              backgroundColor: colors.orange_2,
              title: (
                <FormattedMessage
                  id="notificationTimeline.card.metric.inappropriate.violentOrRepulsiveContent.tooltip"
                  values={{
                    value: tabDetail[REPORTS]['2'].length,
                    b: (text) => <span className="font-bold">{text}</span>,
                    newline: <br />,
                  }}
                />
              ),
            },
            {
              value: tabDetail[REPORTS]['3'].length,
              backgroundColor: colors.orange_3,
              title: (
                <FormattedMessage
                  id="notificationTimeline.card.metric.inappropriate.hatefulOrAbusiveContent.tooltip"
                  values={{
                    value: tabDetail[REPORTS]['3'].length,
                    b: (text) => <span className="font-bold">{text}</span>,
                    newline: <br />,
                  }}
                />
              ),
            },
            {
              value: tabDetail[REPORTS]['4'].length,
              backgroundColor: colors.orange_4,
              title: (
                <FormattedMessage
                  id="notificationTimeline.card.metric.inappropriate.harmfulOrDangerousAct.tooltip"
                  values={{
                    value: tabDetail[REPORTS]['4'].length,
                    b: (text) => <span className="font-bold">{text}</span>,
                    newline: <br />,
                  }}
                />
              ),
            },
            {
              value: tabDetail[REPORTS]['5'].length,
              backgroundColor: colors.orange_5,
              title: (
                <FormattedMessage
                  id="notificationTimeline.card.metric.inappropriate.spamOrMisleading.tooltip"
                  values={{
                    value: tabDetail[REPORTS]['5'].length,
                    b: (text) => <span className="font-bold">{text}</span>,
                    newline: <br />,
                  }}
                />
              ),
            },
          )
        break
      } else if (tabType === DELIVER) {
        arr.push(
          tabDetail[APP]
            ? [
                {
                  value: tabDetail[APP][RECEIVED].length,
                  backgroundColor: colors.green,
                  title: title || messageForEmptyCase,
                },
                {
                  value: tabDetail[APP][NOTRECEIVE].length,
                  backgroundColor: colors.gray,
                  title: formatMessage(
                    { id: 'metrics.didnt.recieve.hover.message' },
                    { count: tabDetail[APP][NOTRECEIVE].length },
                  ),
                },
              ]
            : [],
        )
        arr.push(
          tabDetail[SMS]
            ? [
                {
                  value: tabDetail[SMS][RECEIVED].length,
                  backgroundColor: colors.green,
                  title: title || messageForEmptyCase,
                },
                {
                  value: tabDetail[SMS][NOTRECEIVE].length,
                  backgroundColor: colors.gray,
                  title: formatMessage(
                    { id: 'metrics.didnt.recieve.hover.message' },
                    { count: tabDetail[SMS][NOTRECEIVE].length },
                  ),
                },
              ]
            : [],
        )
        arr.push(
          tabDetail[EMAIL]
            ? [
                {
                  value: tabDetail[EMAIL][RECEIVED].length,
                  backgroundColor: colors.green,
                  title: title || messageForEmptyCase,
                },
                {
                  value: tabDetail[EMAIL][NOTRECEIVE].length,
                  backgroundColor: colors.gray,
                  title: formatMessage(
                    { id: 'metrics.didnt.recieve.hover.message' },
                    { count: tabDetail[EMAIL][NOTRECEIVE].length },
                  ),
                },
              ]
            : [],
        )
        arr.push(
          tabDetail[AUTOMATE_CALL]
            ? [
                {
                  value: tabDetail[AUTOMATE_CALL][RECEIVED].length,
                  backgroundColor: colors.green,
                  title: title || messageForEmptyCase,
                },
                {
                  value: tabDetail[AUTOMATE_CALL][NOTRECEIVE].length,
                  backgroundColor: colors.gray,
                  title: formatMessage(
                    { id: 'metrics.didnt.recieve.hover.message' },
                    { count: tabDetail[AUTOMATE_CALL][NOTRECEIVE].length },
                  ),
                },
              ]
            : [],
        )
        break
      } else {
        arr.push({
          value: tabDetail[value].length,
          backgroundColor: color,
          title: title || messageForEmptyCase,
          isFlag: false,
        })
      }
    }
    setArrayForFlags(flagsArray)
    setListForStackedBarChart(arr)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabDetail])
  let firstSubscriber,
    currentSubscribersCount,
    flagsFirstSubscriber = '',
    flagsSubscribersCount = 0,
    subscribersCount = 0

  // eslint-disable-next-line no-unused-vars
  for (let item in tabDetail) {
    currentSubscribersCount =
      (tabDetail[LIKES] &&
        tabDetail[LIKES][LIKED] &&
        tabDetail[LIKES][LIKED].length) ||
      (tabDetail[LISTENED] &&
        tabDetail[FULL_LISTENED] &&
        tabDetail[LISTENED].length + tabDetail[FULL_LISTENED].length) ||
      (tabDetail[OPENED] && tabDetail[OPENED].length)
    if (tabDetail[READ] && tabDetail[FEEDREAD]) {
      const arrViewRate = R.concat(tabDetail[READ], tabDetail[FEEDREAD])
      currentSubscribersCount = R.uniq(arrViewRate).length
    }

    firstSubscriber =
      (tabDetail[FEEDREAD] && tabDetail[FEEDREAD][0]) ||
      (tabDetail[READ] && tabDetail[READ][0]) ||
      (tabDetail[LIKES] &&
        tabDetail[LIKES][LIKED] &&
        tabDetail[LIKES][LIKED][0]) ||
      (tabDetail[FULL_LISTENED] && tabDetail[FULL_LISTENED][0]) ||
      (tabDetail[LISTENED] && tabDetail[LISTENED][0]) ||
      (tabDetail[OPENED] && tabDetail[OPENED][0])
    if (tabDetail[REPORTS]) {
      for (item in tabDetail[REPORTS]) {
        flagsSubscribersCount += tabDetail[REPORTS][item].length
      }
    }
    break
  }

  // eslint-disable-next-line no-unused-vars
  for (let item in tabDetail) {
    if (
      Object.keys(tabDetail).includes(LIKES) &&
      Object.keys(tabDetail).includes(REPORTS)
    ) {
      // eslint-disable-next-line no-unused-vars
      for (let likesItem in tabDetail[LIKES]) {
        subscribersCount += tabDetail[LIKES][likesItem].length
      }
    }

    if (!Object.keys(tabDetail).includes(LIKES && APP && SMS && EMAIL)) {
      subscribersCount += tabDetail[item].length
    }
    if (tabDetail[REPORTS]) {
      for (item in tabDetail[REPORTS]) {
        if (flagsFirstSubscriber === '') {
          if (tabDetail[REPORTS][item].length) {
            flagsFirstSubscriber = tabDetail[REPORTS][item][0]
          }
        }
      }
    }
  }
  const countDeliverApp = tabDetail &&
    tabDetail[APP] && {
      [RECEIVED]: tabDetail[APP][RECEIVED].length,
      [NOTRECEIVE]: tabDetail[APP][NOTRECEIVE].length,
      total:
        tabDetail[APP][RECEIVED].length + tabDetail[APP][NOTRECEIVE].length,
    }

  const countDeliverSMS = tabDetail &&
    tabDetail[SMS] && {
      [RECEIVED]: tabDetail[SMS][RECEIVED].length,
      [NOTRECEIVE]: tabDetail[SMS][NOTRECEIVE].length,
      total:
        tabDetail[SMS][RECEIVED].length + tabDetail[SMS][NOTRECEIVE].length,
    }

  const countDeliverEmail = tabDetail &&
    tabDetail[EMAIL] && {
      [RECEIVED]: tabDetail[EMAIL][RECEIVED].length,
      [NOTRECEIVE]: tabDetail[EMAIL][NOTRECEIVE].length,
      total:
        tabDetail[EMAIL][RECEIVED].length + tabDetail[EMAIL][NOTRECEIVE].length,
    }

  const countDeliverAutomatedCall = tabDetail &&
    tabDetail[AUTOMATE_CALL] && {
      [RECEIVED]: tabDetail[AUTOMATE_CALL][RECEIVED].length,
      [NOTRECEIVE]: tabDetail[AUTOMATE_CALL][NOTRECEIVE].length,
      total:
        tabDetail[AUTOMATE_CALL][RECEIVED].length +
        tabDetail[AUTOMATE_CALL][NOTRECEIVE].length,
    }

  let subTitles = [],
    flagSubTitles = []
  if (tabDetail) {
    // eslint-disable-next-line no-unused-vars
    for (let value in tabDetail) {
      switch (value) {
        case APP || SMS || EMAIL || AUTOMATE_CALL:
          subTitles.push(
            {
              name: formatMessage({ id: 'metrics.received.title' }),
              value: [RECEIVED],
            },
            {
              name: formatMessage({ id: 'metrics.notReceived.title' }),
              value: [NOTRECEIVE],
            },
          )
          break
        case LIKES:
          subTitles.push({ value })
          break
        case REPORTS:
          flagSubTitles.push(
            {
              id: 1,
              name: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.sexualContent.title',
              }),
              value: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.sexualContent.title',
              }),
            },
            {
              id: 2,
              name: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.violentOrRepulsiveContent.title',
              }),
              value: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.violentOrRepulsiveContent.title',
              }),
            },
            {
              id: 3,
              name: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.hatefulOrAbusiveContent.title',
              }),
              value: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.hatefulOrAbusiveContent.title',
              }),
            },
            {
              id: 4,
              name: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.harmfulOrDangerousAct.title',
              }),
              value: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.harmfulOrDangerousAct.title',
              }),
            },
            {
              id: 5,
              name: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.spamOrMisleading.title',
              }),
              value: formatMessage({
                id: 'notificationTimeline.card.metric.inappropriate.spamOrMisleading.title',
              }),
            },
          )
          break
        case FULL_LISTENED:
          subTitles[1] = {
            name: formatMessage({ id: 'metrics.full.listened' }),
            value,
          }
          break
        case LISTENED:
          subTitles[0] = {
            name: formatMessage({ id: 'metrics.listened' }),
            value,
          }
          break
        case FEEDREAD:
          subTitles.push({
            name: formatMessage({ id: 'metrics.feed.read' }),
            value,
          })
          break
        case READ:
          subTitles.push({
            name: formatMessage({ id: 'metrics.read' }),
            value,
          })
          break
        case OPENED:
          subTitles.push({
            name: formatMessage({ id: 'metrics.media.title' }),
            value,
          })
          break
        default:
          break
      }
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleChangeIndex = (index) => setValue(index)
  let titles = []
  const getCurrentTitle = () => {
    if (tabDetail && tabType === DELIVER) {
      titles.push(
        {
          app: `${appName} ${CHANNEL_APP_TEXT}`,
        },
        {
          sms: CHANNEL_SMS_TEXT,
        },
        {
          email: CHANNEL_EMAIL_TEXT,
        },
        {
          automated: CHANNEL_AUTOMATE_CALL,
        },
      )
    }
    if (tabDetail && tabDetail[LIKES]) {
      titles.push({
        liked: (
          <FormattedMessage id="notificationTimeline.card.metric.userReaction.title" />
        ),
      })
    }
    if (tabDetail && tabDetail[REPORTS]) {
      titles.push({
        reports: (
          <FormattedMessage id="notificationTimeline.card.metric.userReaction.inappropriateBreakdown.title" />
        ),
      })
    } else {
      titles.push({
        name: tabTitles.find((field) => field.value === tabType).title,
      })
    }
    return titles
  }
  const handleSetType = (value) => {
    setIsShow(false)
    setType(value)
  }

  let emptyMessageForMedia =
    tabDetail &&
    tabDetail[OPENED] &&
    tabDetail[OPENED].length === 0 &&
    tabDetail[DIDNT_OPEN] &&
    tabDetail[DIDNT_OPEN].length === 0
      ? formatMessage({ id: 'metrics.media.no.attached.file.text' })
      : null
  let emptyMessageForTTS =
    tabDetail &&
    tabDetail[FULL_LISTENED] &&
    tabDetail[FULL_LISTENED].length === 0 &&
    tabDetail[LISTENED] &&
    tabDetail[LISTENED].length === 0
      ? formatMessage({ id: 'metrics.tts.not.available.message' })
      : null

  const initiateDescriptionForMetric = (type, necessaryFields, count) => {
    let sentences = []
    switch (type) {
      case READ:
        Object.keys(necessaryFields).includes(FEEDREAD) &&
          sentences.push({
            color: colors.yellow,
            count: necessaryFields[FEEDREAD],
            text: (
              <FormattedMessage
                id="metrics.view.rate.feed.read.message"
                values={{
                  count: necessaryFields[FEEDREAD],
                }}
              />
            ),
            isShown: necessaryFields[FEEDREAD] > 0,
          })
        Object.keys(necessaryFields).includes(READ) &&
          sentences.push({
            color: colors.green,
            text: (
              <FormattedMessage
                id="metrics.view.rate.read.message"
                values={{
                  count: necessaryFields[READ],
                }}
              />
            ),
            isShown: necessaryFields[READ] > 0,
          })
        break
      case LIKED:
        Object.keys(necessaryFields).includes(LIKED) &&
          sentences.push({
            color: colors.green,
            text: (
              <FormattedMessage
                id="metrics.user.reaction.success.message"
                values={{
                  count: necessaryFields[LIKED],
                }}
              />
            ),
            isShown: necessaryFields[LIKED] > 0,
          })
        break
      case 'tts':
        Object.keys(necessaryFields).includes(FULL_LISTENED) &&
          sentences.push({
            color: colors.green,
            text: (
              <FormattedMessage
                id="metrics.full.listened.message"
                values={{
                  count: necessaryFields[FULL_LISTENED],
                }}
              />
            ),
            isShown: necessaryFields[FULL_LISTENED] > 0,
          })
        Object.keys(necessaryFields).includes('lisened') &&
          sentences.push({
            color: colors.yellow,
            text: (
              <FormattedMessage
                id="metrics.listened.message"
                values={{
                  count: necessaryFields['lisened'],
                }}
              />
            ),
            isShown: necessaryFields['lisened'] > 0,
          })
        break
      case 'media':
        Object.keys(necessaryFields).includes(OPENED) &&
          sentences.push({
            color: colors.green,
            count: necessaryFields[OPENED],
            text: (
              <FormattedMessage
                id="metrics.media.opened.read.message"
                values={{
                  count: necessaryFields[OPENED],
                }}
              />
            ),
            isShown: necessaryFields[OPENED] > 0,
          })
        break
      default:
        break
    }
    return sentences
  }
  return (
    <div>
      <AppBar
        position="static"
        color="default"
        className={classes.MuiPaperRoot}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
          classes={{ indicator: classes.indicator }}
          className={classes.MuiTabsFlexContainer}
        >
          {tabTitles.map(({ id, title, value }) => (
            <Tab
              label={title}
              {...additionalStyleProps(id)}
              classes={{
                selected: classes.selectedTab,
                root: classes.tabStyle,
              }}
              onClick={() => handleSetType(value)}
              key={id}
            />
          ))}
        </Tabs>
      </AppBar>
      {isShow ? (
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel
            value={value}
            index={tabType === DELIVER && 0}
            dir={theme.direction}
          >
            {tabDetail && (
              <div className="pb-10">
                <div className={clsx(classes.darkGreyText, 'font-semibold')}>
                  <FormattedMessage id="metrics.delivery.rate" />
                </div>
                <div className={classes.descriptionContainer}>
                  <span
                    className={classes.circleStyle}
                    style={{ backgroundColor: colors.green }}
                  />
                  <p>
                    <FormattedMessage
                      id="metrics.delivery.rate.success.message"
                      values={{
                        b: (text) => <span className="font-bold">{text}</span>,
                        to:
                          (!R.isNil(tabDetail[APP]) && countDeliverApp.total) +
                          (!R.isNil(tabDetail[SMS]) && countDeliverSMS.total) +
                          (!R.isNil(tabDetail[EMAIL]) &&
                            countDeliverEmail.total) +
                          (!R.isNil(tabDetail[AUTOMATE_CALL]) &&
                            countDeliverAutomatedCall.total),
                        from:
                          (!R.isNil(tabDetail[APP]) &&
                            countDeliverApp[RECEIVED]) +
                          (!R.isNil(tabDetail[SMS]) &&
                            countDeliverSMS[RECEIVED]) +
                          (!R.isNil(tabDetail[EMAIL]) &&
                            countDeliverEmail[RECEIVED]) +
                          (!R.isNil(tabDetail[AUTOMATE_CALL]) &&
                            countDeliverAutomatedCall[RECEIVED]),
                      }}
                    />
                  </p>
                </div>
              </div>
            )}
            {tabDetail &&
              !R.isNil(tabDetail[APP]) &&
              Object.keys(tabDetail).includes(APP) && (
                <MetricsDetailContent
                  tabTitles={tabs['DeliveryRate']}
                  title={getCurrentTitle()[0].app}
                  titleIcon={
                    <img
                      src={appLogo}
                      className="object-contain mr-2 rounded-full"
                      width={20}
                      height={20}
                      alt="App"
                    />
                  }
                  titleDescription={formatMessage(
                    {
                      id: 'metrics.delivery.title.desescription.app',
                    },
                    { value: getCurrentTitle()[0].app },
                  )}
                  subTitles={subTitles.length && [subTitles[0]]}
                  description={initiateDescriptionForMetric(
                    tabType,
                    {
                      received: countDeliverApp[RECEIVED],
                    },
                    countDeliverApp.total,
                  )}
                  tabDetail={tabDetail[APP]}
                  subscribersCount={countDeliverApp.total}
                  listForStackedBarChart={listForStackedBarChart[0]}
                  firstSubscriber={tabDetail[APP][RECEIVED][0]}
                  currentSubscribersCount={countDeliverApp[RECEIVED]}
                  optional={`${countDeliverApp[RECEIVED]}/${countDeliverApp.total}`}
                  showOtherSubscriberList={
                    !R.isEmpty(tabDetail[APP][NOTRECEIVE])
                  }
                  otherFirstSubscriber={tabDetail[APP][NOTRECEIVE][0]}
                  otherCurrentSubscribersCount={countDeliverApp[NOTRECEIVE]}
                  otherSubTitles={subTitles.length && [subTitles[1]]}
                />
              )}
            {tabDetail &&
              !R.isNil(tabDetail[SMS]) &&
              Object.keys(tabDetail).includes(SMS) && (
                <MetricsDetailContent
                  tabTitles={tabs['DeliveryRate']}
                  title={getCurrentTitle()[1].sms}
                  titleIcon={
                    <img
                      src={Assets.channels.smsIconBlack}
                      className="object-contain mr-2"
                      width={20}
                      height={20}
                      alt="sms"
                    />
                  }
                  titleDescription={formatMessage({
                    id: 'metrics.delivery.title.desescription.sms',
                  })}
                  subTitles={subTitles.length && [subTitles[0]]}
                  description={initiateDescriptionForMetric(
                    tabType,
                    {
                      received: countDeliverSMS[RECEIVED],
                    },
                    countDeliverSMS.total,
                  )}
                  tabDetail={tabDetail[SMS]}
                  subscribersCount={countDeliverSMS.total}
                  listForStackedBarChart={listForStackedBarChart[1]}
                  firstSubscriber={tabDetail[SMS][RECEIVED][0]}
                  currentSubscribersCount={countDeliverSMS[RECEIVED]}
                  optional={`${countDeliverSMS[RECEIVED]}/${countDeliverSMS.total}`}
                  showOtherSubscriberList={
                    !R.isEmpty(tabDetail[SMS][NOTRECEIVE])
                  }
                  otherFirstSubscriber={tabDetail[SMS][NOTRECEIVE][0]}
                  otherCurrentSubscribersCount={countDeliverSMS[NOTRECEIVE]}
                  otherSubTitles={subTitles.length && [subTitles[1]]}
                />
              )}
            {tabDetail &&
              !R.isNil(tabDetail[EMAIL]) &&
              Object.keys(tabDetail).includes(EMAIL) && (
                <MetricsDetailContent
                  tabTitles={tabs['DeliveryRate']}
                  title={getCurrentTitle()[2].email}
                  titleIcon={
                    <img
                      src={Assets.channels.emailIconBlack}
                      className="object-contain mr-2"
                      width={20}
                      height={20}
                      alt="sms"
                    />
                  }
                  titleDescription={formatMessage({
                    id: 'metrics.delivery.title.desescription.email',
                  })}
                  subTitles={subTitles.length && [subTitles[0]]}
                  description={initiateDescriptionForMetric(
                    tabType,
                    {
                      received: countDeliverEmail[RECEIVED],
                    },
                    countDeliverEmail.total,
                  )}
                  tabDetail={tabDetail[EMAIL]}
                  subscribersCount={countDeliverEmail.total}
                  listForStackedBarChart={listForStackedBarChart[2]}
                  firstSubscriber={tabDetail[EMAIL][RECEIVED][0]}
                  currentSubscribersCount={countDeliverEmail[RECEIVED]}
                  optional={`${countDeliverEmail[RECEIVED]}/${countDeliverEmail.total}`}
                  showOtherSubscriberList={
                    !R.isEmpty(tabDetail[EMAIL][NOTRECEIVE])
                  }
                  otherFirstSubscriber={tabDetail[EMAIL][NOTRECEIVE][0]}
                  otherCurrentSubscribersCount={countDeliverEmail[NOTRECEIVE]}
                  otherSubTitles={subTitles.length && [subTitles[1]]}
                />
              )}
            {tabDetail &&
              !R.isNil(tabDetail[AUTOMATE_CALL]) &&
              Object.keys(tabDetail).includes(AUTOMATE_CALL) && (
                <MetricsDetailContent
                  tabTitles={tabs['DeliveryRate']}
                  title={getCurrentTitle()[3].automated}
                  titleIcon={
                    <img
                      src={Assets.channels.automateCallBlack}
                      className="object-contain mr-2"
                      width={20}
                      height={20}
                      alt={CHANNEL_AUTOMATE_CALL}
                    />
                  }
                  titleDescription={formatMessage({
                    id: 'metrics.delivery.title.desescription.automateCall',
                  })}
                  subTitles={subTitles.length && [subTitles[0]]}
                  description={initiateDescriptionForMetric(
                    tabType,
                    {
                      received: countDeliverAutomatedCall[RECEIVED],
                    },
                    countDeliverAutomatedCall.total,
                  )}
                  tabDetail={tabDetail[AUTOMATE_CALL]}
                  subscribersCount={countDeliverAutomatedCall.total}
                  listForStackedBarChart={listForStackedBarChart[3]}
                  firstSubscriber={tabDetail[AUTOMATE_CALL][RECEIVED][0]}
                  currentSubscribersCount={countDeliverAutomatedCall[RECEIVED]}
                  optional={`${countDeliverAutomatedCall[RECEIVED]}/${countDeliverAutomatedCall.total}`}
                  showOtherSubscriberList={
                    !R.isEmpty(tabDetail[AUTOMATE_CALL][NOTRECEIVE])
                  }
                  otherFirstSubscriber={tabDetail[AUTOMATE_CALL][NOTRECEIVE][0]}
                  otherCurrentSubscribersCount={
                    countDeliverAutomatedCall[NOTRECEIVE]
                  }
                  otherSubTitles={subTitles.length && [subTitles[1]]}
                />
              )}
          </TabPanel>
          <TabPanel
            value={value}
            index={tabType === READ && 1}
            dir={theme.direction}
          >
            <MetricsDetailContent
              tabTitles={tabs['ViewRate']}
              title={getCurrentTitle()[0].name}
              subTitles={subTitles.length && subTitles}
              description={initiateDescriptionForMetric(
                tabType,
                {
                  feedRead:
                    tabDetail &&
                    tabDetail.feedRead &&
                    tabDetail.feedRead.length,
                  read: tabDetail && tabDetail.read && tabDetail.read.length,
                },
                subscribersCount,
              )}
              tabDetail={tabDetail}
              subscribersCount={subscribersCount}
              listForStackedBarChart={listForStackedBarChart}
              firstSubscriber={firstSubscriber}
              currentSubscribersCount={currentSubscribersCount}
            />
          </TabPanel>
          <TabPanel
            value={value}
            index={tabType === REACTION && 2}
            dir={theme.direction}
          >
            {tabDetail && Object.keys(tabDetail).includes(LIKES) && (
              <MetricsDetailContent
                tabTitles={tabs['UserReaction']}
                title={getCurrentTitle()[0].liked}
                subTitles={subTitles.length && [{ ...subTitles[0] }]}
                description={initiateDescriptionForMetric(
                  (tabType = LIKED),
                  {
                    liked:
                      tabDetail &&
                      tabDetail.likes &&
                      tabDetail.likes.liked &&
                      tabDetail.likes.liked.length,
                  },
                  subscribersCount,
                )}
                tabDetail={tabDetail}
                subscribersCount={subscribersCount}
                listForStackedBarChart={listForStackedBarChart}
                firstSubscriber={firstSubscriber}
                currentSubscribersCount={currentSubscribersCount}
              />
            )}
            {tabDetail && Object.keys(tabDetail).includes(REPORTS) && (
              <MetricsDetailContent
                title={getCurrentTitle()[1].reports}
                flagSubTitles={flagSubTitles.length && flagSubTitles}
                description={initiateDescriptionForMetric(
                  tabType,
                  { reports: tabDetail && tabDetail.reports },
                  subscribersCount,
                )}
                tabDetail={tabDetail}
                subscribersCount={flagsSubscribersCount}
                listForStackedBarChart={arrayForFlags}
                firstSubscriber={flagsFirstSubscriber}
                currentSubscribersCount={flagsSubscribersCount}
                customStyles={{ marginTop: '1rem' }}
              />
            )}
          </TabPanel>
          <TabPanel
            value={value}
            index={tabType === 'tts' && 3}
            dir={theme.direction}
          >
            {R.isNil(tabDetail) ? null : (
              <MetricsDetailContent
                tabTitles={tabs['Listen(TTS)']}
                title={getCurrentTitle()[0].name}
                subTitles={subTitles.length && subTitles}
                description={initiateDescriptionForMetric(
                  tabType,
                  {
                    fullListened: tabDetail?.fullListened?.length,
                    lisened: tabDetail?.listened?.length,
                  },
                  subscribersCount,
                )}
                tabDetail={{
                  ...tabDetail,
                  didntListened:
                    subscribersCount -
                    (tabDetail?.fullListened?.length +
                      tabDetail?.listened?.length),
                }}
                subscribersCount={subscribersCount}
                listForStackedBarChart={listForStackedBarChart}
                emptyMessage={emptyMessageForTTS}
                firstSubscriber={firstSubscriber}
                currentSubscribersCount={currentSubscribersCount}
              />
            )}
          </TabPanel>
          <TabPanel
            value={value}
            index={tabType === 'media' && 4}
            dir={theme.direction}
          >
            <MetricsDetailContent
              tabTitles={tabs['MediaOpened']}
              title={getCurrentTitle()[0].name}
              subTitles={subTitles.length && subTitles}
              description={initiateDescriptionForMetric(
                tabType,
                {
                  opened:
                    tabDetail && tabDetail.opened && tabDetail.opened.length,
                },
                subscribersCount,
              )}
              tabDetail={tabDetail}
              subscribersCount={subscribersCount}
              listForStackedBarChart={listForStackedBarChart}
              emptyMessage={emptyMessageForMedia}
              firstSubscriber={firstSubscriber}
              currentSubscribersCount={currentSubscribersCount}
            />
          </TabPanel>
          <TabPanel
            value={value}
            index={tabType === SOCIAL_MEDIA_INTERACTIONS && 5}
          >
            <SocialMediaInteractionsTab socialMediaTabDetails={tabDetail} />
          </TabPanel>
        </SwipeableViews>
      ) : (
        <div className={classes.root}>
          <CircularProgress />
        </div>
      )}
    </div>
  )
}

export default TabsContainer
